import { HoverCard, HoverCardContent, HoverCardTrigger } from '@chain-zen/ui'

import type { TELDAppSource } from '../../../types/tracking'
import { ELDAppInfo } from './eld-app-info'
import { ELDAppTrackingInfo } from './eld-app-tracking-info'

interface IELDAppSourceProps {
  trackingSourceData: TELDAppSource
}

/**
 * ELDAppSource displays the ELD app data for the shipment.
 */
export const ELDAppSource = (props: IELDAppSourceProps) => {
  const { trackingSourceData } = props

  return (
    <HoverCard>
      <HoverCardTrigger className="w-full">
        <div className="w-full">
          <ELDAppInfo trackingSourceData={trackingSourceData} />
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-full text-sm" side="top">
        <ELDAppTrackingInfo trackingSourceData={trackingSourceData} />
      </HoverCardContent>
    </HoverCard>
  )
}
